import { useQuery } from "@tanstack/react-query"
import { Notification, NotificationWithAvatar, NormalizedPayload, AvatarField } from "@/models/Notification.ts"
import { axiosClient } from "@/services/api/axiosClient.ts"
import { apiRoutes } from "@/services/api/api-routes.ts"

const getAvatarField = (payload: NormalizedPayload): AvatarField => {
  if ("author" in payload) {
    return {
      avatar: payload.authorAvatar,
      name: payload.author
    }
  }

  if ("reviewer" in payload) {
    return {
      avatar: payload.reviewerAvatar,
      name: payload.reviewer
    }
  }

  if ("resolvedBy" in payload) {
    return {
      avatar: payload.resolvedByAvatar,
      name: payload.resolvedBy
    }
  }

  if ("updater" in payload) {
    return {
      avatar: payload.updaterAvatar,
      name: payload.updater
    }
  }

  return { name: "User" }
}

export const useFetchNotifications = () => {
  const {
    data: rawNotifications,
    error,
    isLoading
  } = useQuery<Notification[]>({
    queryKey: ["notifications"],
    queryFn: async () => {
      const response = await axiosClient.get(apiRoutes.notifications.get, {})
      return response.data
    }
  })

  const data: NotificationWithAvatar[] =
    rawNotifications?.map((notification) => ({
      ...notification,
      avatarField: getAvatarField(notification.payload)
    })) || []

  return { data, error, isLoading }
}
